module.exports = __webpack_public_path__ + "static/media/success.0d075187.jpg";